import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Produktbaustein, If, FormRadio,
  appActions, istEnumAuswahl, EnumVorgangsart, Message, updateWindowHeightForIF, trEnv,
} from 'ion-lib';
import i18next from 'i18next';
import { EnumNeuordnung } from '../../enum';

const Glasversicherung = ({
  baustein,
  bausteinIndex,
  handleChange,
  glasart,
  handleChangeGlasArt,
}) => {
  const dispatch = useDispatch();
  const [showAlert, setAlert] = useState(false);
  const vorgangsart = useSelector((state) => state.daten.vorgangsart);
  const auswahlNeuordnung = useSelector((state) => state.daten.auswahlNeuordnung);

  const alertNeuordnungHausrat = trEnv.ifiliale
    ? i18next.t('produktvergleich.zusatz.glasversicherung_alert_neuordnung_hausrat_medial')
    : i18next.t('produktvergleich.zusatz.glasversicherung_alert_neuordnung_hausrat');

  return (
    baustein.relevant && (
    <Produktbaustein
      title="Glasversicherung"
      tooltip={() => dispatch(appActions.toggleModal(i18next.t('produktvergleich.zusatz.glasversicherung_tt')))}
      onChange={handleChange}
      name={`daten.bausteine.${bausteinIndex}.glasversicherung.value`}
      checkbox={baustein}
      onClick={() => {
        if (!baustein.ueberschreibbar) {
          setAlert(true);
          updateWindowHeightForIF();
        }
      }}
    >
      <p dangerouslySetInnerHTML={{ __html: i18next.t('produktvergleich.zusatz.glasversicherung_beschreibung') }} />
      <If predicate={istEnumAuswahl(vorgangsart, EnumVorgangsart.NEUORDNUNG) && showAlert}>
        <Message
          show
          dismissible
          onAfterClose={() => {
            setAlert(false);
            updateWindowHeightForIF();
          }}
          text={(istEnumAuswahl(auswahlNeuordnung, EnumNeuordnung.HAUSRAT) || trEnv.ifiliale)
            ? alertNeuordnungHausrat
            : i18next.t('produktvergleich.zusatz.glasversicherung_alert_neuordnung_haushaltglas')}
          variant="dark"
        />
      </If>
      <If predicate={glasart.relevant}>
        <FormRadio
          {...glasart}
          className="produktbaustein__auswahl mb-5"
          title="Bitte wählen Sie:"
          name={`daten.bausteine.${bausteinIndex}.glasversicherungArt.value`}
          onChange={handleChangeGlasArt}
          inputClassName="vertical"
        />
      </If>
    </Produktbaustein>
    )
  );
};

export default Glasversicherung;
